export class Airway {
    id: string;
    label: string;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
